import { useValueSlashMenu } from '../../useValueSlashMenu';
import { slashQueryFrom } from '../../valueSlash';
import { deleteCharsBeforeCaret, getTextBeforeCaret } from '../utils/caret';

/** "/" menu for inserting a variable or a math pill. */
export function useNestedSlashField({
  elRef,
  readOnly,
  slashAllowed,
  openMathAtCaret,
  openPickerAtCaret,
}) {
  const deleteSlashQuery = () => {
    const before = getTextBeforeCaret(elRef.current);
    const query = slashQueryFrom(before);
    if (query == null) return;
    deleteCharsBeforeCaret(query.length + 1);
  };

  const caretMenuPosition = () => {
    const el = elRef.current;
    const sel = window.getSelection();
    if (sel?.rangeCount && el?.contains(sel.anchorNode)) {
      try {
        const rect = sel.getRangeAt(0).getBoundingClientRect();
        if (rect.left || rect.top) {
          return { x: rect.left, y: rect.bottom + 4, caretTop: rect.top };
        }
      } catch {
        /* jsdom ranges have no client rect; fall through to the field box */
      }
    }
    const box = el?.getBoundingClientRect();
    return {
      x: box?.left || 0,
      y: (box?.bottom || 0) + 4,
      caretTop: box?.top || 0,
    };
  };

  const { slashMenu, slashOpenRef, openAt, setQuery, close: closeSlash } = useValueSlashMenu({
    allowedIds: slashAllowed,
    readOnly,
    onPick: (id) => {
      deleteSlashQuery();
      if (id === 'math') openMathAtCaret();
      if (id === 'variable') openPickerAtCaret();
    },
    onDismiss: deleteSlashQuery,
  });

  return { slashMenu, slashOpenRef, openAt, setQuery, closeSlash, caretMenuPosition };
}
